export default __webpack_public_path__ + "assets/aanrader.46f9fefa.svg";